import { AnimatePresence, motion } from 'framer-motion'

import { cn } from '../../lib/utils'
import { disclosureVariants } from '../../lib/motion'

export function AnimatedDisclosure({ open, children, className, contentClassName }) {
  return (
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          className={cn('overflow-hidden', className)}
          variants={disclosureVariants}
          initial='collapsed'
          animate='expanded'
          exit='collapsed'
        >
          <div className={contentClassName}>{children}</div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
